var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileRound13451(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2383_10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6748 5.39999C12.6748 3.41459 11.0267 1.79999 9.00001 1.79999C6.97335 1.79999 5.32519 3.41459 5.32519 5.39999C5.32519 7.38539 6.97335 8.99999 9.00001 8.99999C11.0267 8.99999 12.6748 7.38539 12.6748 5.39999ZM16.1512 18H14.5122C14.0051 18 13.5935 17.5968 13.5935 17.1C13.5935 16.6032 14.0051 16.2 14.5122 16.2H14.9063C15.5421 16.2 16.0116 15.5727 15.7709 14.9958C14.6583 12.3282 12.0455 10.8 9.00001 10.8C5.95451 10.8 3.34171 12.3282 2.22917 14.9958C1.98846 15.5727 2.45794 16.2 3.09368 16.2H3.48779C3.99491 16.2 4.40649 16.6032 4.40649 17.1C4.40649 17.5968 3.99491 18 3.48779 18H1.84882C0.70044 18 -0.203564 16.9713 0.0398925 15.8724C0.708708 12.8493 2.79693 10.6182 5.54753 9.60566C4.29258 8.61656 3.48779 7.10099 3.48779 5.39999C3.48779 2.20409 6.32108 -0.342921 9.66056 0.0377792C12.0804 0.313179 14.085 2.20224 14.4479 4.56294C14.7603 6.59784 13.9105 8.45636 12.4525 9.60566C15.2031 10.6182 17.2913 12.8493 17.9601 15.8724C18.2036 16.9713 17.2996 18 16.1512 18ZM11.8673 13.9176C12.2265 14.2695 12.2265 14.8392 11.8673 15.1911L9.00001 18L7.05145 16.0911C6.69224 15.7392 6.69224 15.1695 7.05145 14.8176C7.40974 14.4666 7.99129 14.4666 8.3505 14.8176L9.00001 15.4548L10.5682 13.9176C10.9274 13.5666 11.509 13.5666 11.8673 13.9176Z",
    fill: "#52447D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2383_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRound13451);
export default __webpack_public_path__ + "static/media/profile-round-1345 1.b6c03bf3a55ef33cd566f751577a08b7.svg";
export { ForwardRef as ReactComponent };